import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CodeQualityCard } from "./CodeQualityCard";

export default function SystemHealth() {
  const [h, setH] = useState(null);
  useEffect(() => { api.get("/platform/system-health").then((r) => setH(r.data)).catch(() => setH({ recent: [], failing: 0, version: {} })); }, []);
  return (
    <div className="space-y-6" data-testid="system-health-tab">
      <div className="sc-card p-5" data-testid="self-check-history">
        <div className="label-cap mb-3">Self-check history · backend {h?.version?.version} · build {h?.version?.commit} · {h ? `${h.failing} failing of ${h.recent.length}` : "…"}</div>
        <table className="sc-table w-full text-xs"><thead><tr><th>Checked</th><th>User</th><th>Trigger</th><th>Result</th><th>Detail</th></tr></thead>
          <tbody>{(h?.recent || []).slice(0, 15).map((r) => (
            <tr key={r.id}><td className="font-mono">{new Date(r.checked_at).toLocaleString()}</td><td>{r.user_name}</td><td>{r.trigger}</td>
              <td className={r.ok ? "text-emerald-400" : "text-red-400"}>{r.ok ? "healthy" : r.blocking ? "blocking" : "warning"}</td>
              <td className="text-slate-400">{r.checks.filter((c) => !c.ok).map((c) => c.name).join(", ") || "all checks passed"}</td></tr>
          ))}</tbody></table>
      </div>
      <CodeQualityCard />
    </div>
  );
}
